var $c66676e8620273e7$exports = {};
(function() {
    const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const titles = document.querySelectorAll('.faq .title');
    const states = {
        true: 'remove',
        false: 'add'
    };
    const handleClick = ({ currentTarget: { parentElement: parentElement } })=>{
        const isOpen = parentElement.classList.contains('open');
        titles.forEach((title)=>title.parentElement.classList.remove('open'));
        parentElement.classList[states[isOpen]]('open');
    };
    titles.forEach((title)=>title.onclick = handleClick);
    const slider = document.querySelector('.simple-slider');
    const sliderTrack = slider.querySelector('.simple-slider-track');
    const stepsElements = [
        ...document.querySelectorAll('.bullet')
    ];
    const sliderItemWidth = 100;
    let clientWidth = null;
    let transitionTimeout = null;
    let currentTranslate = -(2 * sliderItemWidth);
    const updateSlider = ()=>{
        if (clientWidth === window.innerWidth) return;
        clientWidth = window.innerWidth;
        const sliderItems = [
            ...slider.querySelectorAll('.simple-slider-item')
        ];
        let startX = 0;
        let isPointerDown = false;
        const onPointerDown = (e)=>{
            if (e.target.nodeName === 'A') return;
            const pageX = e.touches ? e.touches[0].pageX : e.pageX;
            startX = pageX;
            currentTranslate = +sliderTrack.style.transform.replace(/[^-?\d.]/g, '');
            if (currentTranslate === -300) currentTranslate = currentTranslate + 200;
            if (currentTranslate === 0) currentTranslate = currentTranslate - 200;
            sliderTrack.classList.add('moving');
            isPointerDown = true;
        };
        const onPointerUp = (e)=>{
            if (!isPointerDown) return;
            const transformValue = +sliderTrack.style.transform.replace(/[^-?\d.]/g, '');
            const isLeftMoved = currentTranslate >= transformValue;
            sliderTrack.classList.remove('moving');
            isPointerDown = false;
            for(let idx = 0; idx < sliderItems.length; idx += 1){
                const leftPartOfElement = -sliderItemWidth * (idx + 0.25);
                const rightPartOfElement = -sliderItemWidth * (idx + 0.75);
                if (rightPartOfElement >= transformValue && !isLeftMoved) continue;
                if (leftPartOfElement >= transformValue && isLeftMoved) continue;
                currentTranslate = -sliderItemWidth * idx;
                sliderTrack.style.transform = `translateX(${currentTranslate}%)`;
                break;
            }
        };
        const onPointerMove = (e)=>{
            if (!isPointerDown) return;
            const pageX = e.touches ? e.touches[0].pageX : e.pageX;
            const walk = (pageX - startX) / clientWidth * 100;
            const updatedTranslate = currentTranslate + walk;
            if (walk !== 0) clearTimeout(transitionTimeout);
            if (updatedTranslate > 0) {
                sliderTrack.classList.add('moving');
                sliderTrack.style.transform = `translateX(${-sliderItemWidth * 2}%)`;
                return;
            } else if (updatedTranslate < -300) {
                sliderTrack.classList.add('moving');
                sliderTrack.style.transform = `translateX(${-sliderItemWidth}%)`;
                return;
            }
            sliderTrack.style.transform = `translateX(${updatedTranslate}%)`;
        };
        if (!isMobile) {
            sliderTrack.onpointerdown = onPointerDown;
            window.onpointerup = onPointerUp;
            sliderTrack.onpointermove = onPointerMove;
        } else {
            sliderTrack.ontouchstart = onPointerDown;
            window.ontouchend = onPointerUp;
            sliderTrack.ontouchmove = onPointerMove;
        }
        sliderTrack.ontransitionstart = ()=>{
            stepsElements.forEach((element)=>element.classList.remove('active'));
        };
        sliderTrack.ontransitionend = ()=>{
            sliderTrack.classList.add('moving');
            if (currentTranslate === -300) currentTranslate = currentTranslate + 200;
            if (currentTranslate === 0) currentTranslate = currentTranslate - 200;
            const stepIndex = currentTranslate / 100 % 2 === 0 ? 1 : 0;
            stepsElements[stepIndex]?.classList?.add('active');
            sliderTrack.style.transform = `translateX(${currentTranslate}%)`;
            clearTimeout(transitionTimeout);
            transitionTimeout = setTimeout(()=>{
                sliderTrack.classList.remove('moving');
                currentTranslate = currentTranslate - 100;
                sliderTrack.style.transform = `translateX(${currentTranslate}%)`;
            }, 10000);
        };
    };
    // updateSlider();
    // transitionTimeout = setTimeout(() => {
    //   sliderTrack.classList.remove('moving');
    //   currentTranslate = currentTranslate - 100;
    //
    //   sliderTrack.style.transform = `translateX(${currentTranslate}%)`;
    // }, 10000);
    // window.addEventListener('resize', updateSlider);
    const onStepClick = ({ currentTarget: currentTarget })=>{
        if (currentTarget.classList.contains('active')) return;
        const { dataset: { index: index }, parentElement: parentElement } = currentTarget;
        currentTranslate = -sliderItemWidth * index;
        clearTimeout(transitionTimeout);
        sliderTrack.classList.remove('moving');
        parentElement.querySelector('.active')?.classList?.remove('active');
        sliderTrack.style.transform = `translateX(${currentTranslate}%)`;
    };
// stepsElements.map((item) => {
//   item.onclick = onStepClick;
// })
})();


//# sourceMappingURL=index.0b9ceb61.js.map
